/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_EQ_TYPES } from '../../actions.type'
import {
  CREATE_EQ_TYPE,
  REMOVE_EQ_TYPE,
  SET_EQ_TYPE_ALL_REQUEST,
  SET_EQ_TYPE_ALL_VALUE,
  UPDATE_EQ_TYPE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  eqTypeAllValue: (state) => state.all.value,
  eqTypeAllRequest: (state) => state.all.request,
  eqTypeAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_EQ_TYPES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('eq-type', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_EQ_TYPE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_EQ_TYPE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_EQ_TYPE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_EQ_TYPE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_EQ_TYPE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_EQ_TYPE({ commit }, value) {
    commit(CREATE_EQ_TYPE, value)
  },

  async SOCKET_UPDATE_EQ_TYPE({ commit }, value) {
    commit(UPDATE_EQ_TYPE, value)
  },

  async SOCKET_REMOVE_EQ_TYPE({ commit }, id) {
    commit(REMOVE_EQ_TYPE, id)
  }
}

const mutations = {
  [SET_EQ_TYPE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_EQ_TYPE_ALL_VALUE](state, eqTypes) {
    state.all.value = eqTypes
  },
  [UPDATE_EQ_TYPE](state, updatedEqType) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedEqType.id }),
      1,
      updatedEqType
    )
  },
  [CREATE_EQ_TYPE](state, createdEqType) {
    state.all.value.push(createdEqType)
  },
  [REMOVE_EQ_TYPE](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
